import { FlexContainer } from 'base-components';
import styled from 'styled-components';

const SelectIcon = styled(FlexContainer)`
    margin-left: auto;
    margin-top: auto;
    margin-bottom: auto;
    padding: 0px 5px;
    font-size: .2rem;
    color: ${({ color = 'black' }) => color};

    &:hover {
    color: green;
    }
`;

export default SelectIcon;
